import React from "react";
import { Box, Typography } from "@mui/material";

const TypingIndicator = () => (
  <Box sx={{ px: 1, py: 0.5 }}>
    <Typography variant="body2" color="text.secondary">
      Sherpa is thinking...
    </Typography>
  </Box>
);

export default TypingIndicator;

